import React, { useRef, useEffect } from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

// Slide in animation for sidebar
const slideIn = keyframes`
  0% { transform: translateX(100%); opacity: 0; }
  100% { transform: translateX(0); opacity: 1; }
`;

const SidebarOuterContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  width: 500px;
  height: 100vh;
  background-color: ${(props) => props.theme.background.primary};
  box-shadow: ${(props) => props.theme.general.shadow2dp};
  transform: translateX(${(props) => (props.isOpen ? "0" : "100%")});
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 30px 25px 25px;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.4s ease-out;
  border-left: 1px solid ${(props) => props.theme.borderColor};
`;

const SidebarScroll = styled.div`
  position: absolute;
  width: 0.5rem;
  left: -0.25rem;
  top: 0;
  height: 100%;
  cursor: w-resize;
  user-select: none;
`;

export default function SidebarContainer({
  children,
  widthState,
  ...restProps
}) {
  const [width, setWidth] = widthState;
  const moveListenerRef = useRef();
  const mouseUpListenerRef = useRef();

  const removeEventListeners = () => {
    document.removeEventListener("mousemove", moveListenerRef.current);
    document.removeEventListener("mouseup", mouseUpListenerRef.current);
  };

  useEffect(() => {
    return () => {
      removeEventListeners();
    };
  }, []);

  return (
    <SidebarOuterContainer {...restProps} style={{ width }}>
      <SidebarScroll
        onMouseDown={(evt) => {
          const originalX = evt.clientX;
          removeEventListeners();

          moveListenerRef.current = (evt) => {
            setWidth(originalX - evt.clientX + width);
          };
          mouseUpListenerRef.current = () => {
            removeEventListeners();
          };

          document.addEventListener("mousemove", moveListenerRef.current);
          document.addEventListener("mouseup", mouseUpListenerRef.current, {
            once: true,
          });
        }}
      />
      {children}
    </SidebarOuterContainer>
  );
}
